import MobileItemRow from './MobileItemRow';

export default MobileItemRow;
